var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useState } from 'react';
import { checkPassword, checkUsername } from '../../utils/credentials-check';
import { useCheckbox } from '../common/use-checkbox';
import { useInput } from '../common/use-input';
export function useSignUp() {
    var t = useI18n().t;
    var username = useInput('');
    var email = useInput('');
    var password = useInput('');
    var passwordConfirm = useInput('');
    var acceptTosEulaPrivacy = useCheckbox(false);
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(false), success = _b[0], setSuccess = _b[1];
    var _c = useState(undefined), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useState(0), currentStepIndex = _d[0], setCurrentStepIndex = _d[1];
    function next() {
        return __awaiter(this, void 0, void 0, function () {
            var valid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        valid = false;
                        if (!(currentStepIndex === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, submitUsername()];
                    case 1:
                        valid = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(currentStepIndex === 1)) return [3 /*break*/, 4];
                        return [4 /*yield*/, submit()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        setCurrentStepIndex(valid ? Math.min(currentStepIndex + 1, 2) : currentStepIndex);
                        return [2 /*return*/];
                }
            });
        });
    }
    function previous() {
        username.setValue('');
        email.setValue('');
        password.setValue('');
        passwordConfirm.setValue('');
        setErrorMessage(undefined);
        setCurrentStepIndex(function (value) { return value - 1; });
    }
    function submitUsername() {
        return __awaiter(this, void 0, Promise, function () {
            var usernameError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, checkUsername(username.value, t, true)];
                    case 1:
                        usernameError = _a.sent();
                        username.setError(usernameError);
                        return [2 /*return*/, usernameError === undefined];
                }
            });
        });
    }
    function submit() {
        return __awaiter(this, void 0, void 0, function () {
            var error, emailError, passwordError, passwordConfirmError, acceptTosEulaPrivacyError, passed, isInMaintenanceQuery, response, _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        passed = false;
                        if (email.value.length === 0) {
                            emailError = t('error.email-required');
                        }
                        passwordError = checkPassword(password.value, t);
                        if (password.value !== passwordConfirm.value) {
                            passwordConfirmError = t('error.password-confimation');
                        }
                        if (!acceptTosEulaPrivacy.value) {
                            acceptTosEulaPrivacyError = t('error.terms-of-service');
                        }
                        email.setError(emailError);
                        password.setError(passwordError);
                        passwordConfirm.setError(passwordConfirmError);
                        acceptTosEulaPrivacy.setError(acceptTosEulaPrivacyError);
                        setLoading(true);
                        if (!(!error && !emailError && !passwordError && !passwordConfirmError && !acceptTosEulaPrivacyError)) return [3 /*break*/, 5];
                        return [4 /*yield*/, gqlSdk.SystemIsInMaintenance()];
                    case 1:
                        isInMaintenanceQuery = _c.sent();
                        if (isInMaintenanceQuery.systemIsInMaintenance.isInMaintenance) {
                            error = t('error.portal-in-maintenance');
                        }
                        if (!!error) return [3 /*break*/, 5];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, gqlSdk.UserRegister({
                                input: {
                                    username: username.value,
                                    email: email.value.toLowerCase(),
                                    password: password.value,
                                },
                            })];
                    case 3:
                        response = _c.sent();
                        passed = ((_b = response.userRegister) === null || _b === void 0 ? void 0 : _b.successStatus) === 'passed';
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _c.sent();
                        error = t('error.generic');
                        return [3 /*break*/, 5];
                    case 5:
                        setLoading(false);
                        setSuccess(error !== null && passed);
                        setErrorMessage(error);
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        currentStepIndex: currentStepIndex,
        username: username,
        email: email,
        password: password,
        passwordConfirm: passwordConfirm,
        acceptTosEulaPrivacy: acceptTosEulaPrivacy,
        loading: loading,
        success: success,
        errorMessage: errorMessage,
        next: next,
        previous: previous,
    };
}
